import { DocumentsSet } from 'src/app/modules/core/store/models/document.model';

export interface LayerDataChangeEvent {
  type: LayerDataChangeType;
  layerUId: string;
  changes: DocumentsSet;
  floor?: string;
  totalDocumentCount?: number;
}

export enum LayerDataChangeType {
  None = 0,
  /** Documents should be added **/
  Add = 1,
  /** Documents should be updated **/
  Update = 2,
  /** Documents should be removed **/
  Remove = 3,
  /** All layer documents should be removed and replaced with this list **/
  Replace = 4,
  /** Query has failed **/
  Error = 5
}
